import { AnyAction } from 'redux';
import { ErrorData, PaginatedResponse } from '@synergy/api';

import {
    PRODUCT_LIST_ERROR,
    PRODUCT_LIST_RECEIVE_ITEMS,
    PRODUCT_LIST_RESET,
    PRODUCT_LIST_START_GET_ITEMS,
} from './product-actions';
import { ProductListItem } from '../models/product-list-item';

export interface ProductListReducerState {
    paginatedData: PaginatedResponse<ProductListItem>;
    inProgress: boolean;
    error: ErrorData | null;
}

const initialProductReducerState: ProductListReducerState = {
    paginatedData: { limit: 10, page: 0, total: 0, items: [] },
    inProgress: false,
    error: null,
};

export const productListReducer = (
    state: ProductListReducerState = initialProductReducerState,
    action: AnyAction
): ProductListReducerState => {
    switch (action.type) {
        case PRODUCT_LIST_RECEIVE_ITEMS: {
            return {
                ...state,
                paginatedData: action['products'],
                inProgress: false,
                error: null,
            };
        }

        case PRODUCT_LIST_START_GET_ITEMS: {
            return {
                ...state,
                inProgress: true,
            };
        }

        case PRODUCT_LIST_ERROR: {
            return {
                ...state,
                inProgress: false,
                error: action['error'],
            };
        }

        case PRODUCT_LIST_RESET: {
            return { ...initialProductReducerState };
        }

        default: {
            return state;
        }
    }
};
